import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Button, Collapse, Modal, ModalBody, ModalHeader } from "reactstrap";
import { OroLoaderInline } from "../../core";
import Loader from "react-loaders";
import moment from "moment";
import { setAnalyticsEvent } from "../../core/helpers/analytics";
import { initBranch, trackEvent } from "../../core/helpers/branchio";

export default function SelectPaymentModeRfq(props) {
  const {
    openPaymentMode,
    togglePaymentMode,
    paymentMethod,
    onPaymentChange,
    userAmount,
    setpaymentMethod,
    transactionStartTime,
    togglePriceDifferencePopUp,
    priceValidityTime,
    recordDate,
    exchange
  } = props;
  
  const [timer, setTimer] = useState(120);
  const [cancelEnable, setCancelEnable] = useState(true);

  const handlePayClick = () => {
    {
      process.env.REACT_APP_RENDER_GA === "true" &&
      setAnalyticsEvent("Bidd_Payment_Initiated");
    }
    initBranch().then(() => {
    trackEvent(`Bidd_Payment_Initiated`);
  }).catch(error => console.error('Error initializing Branch:', error))
    // Parse all time strings into Date objects
    const currentTime = new Date();
    const transactionStart = new Date();
    const priceValidity = new Date();
  
    // Set the time for each Date object
    const [transactionHours, transactionMinutes, transactionSeconds] = transactionStartTime.split(":").map(Number);
    transactionStart.setHours(transactionHours, transactionMinutes, transactionSeconds);
  
    const [priceHours, priceMinutes] = priceValidityTime.split(":").map(Number);
    priceValidity.setHours(priceHours, priceMinutes, 0); // Assuming priceValidityTime doesn't include seconds
    
    // Perform comparisons
    if (transactionStart < priceValidity && currentTime > priceValidity) {
      setCancelEnable(false);
      togglePriceDifferencePopUp();
    } else {
      setCancelEnable(false);
      togglePaymentMode();
    }
  };  

  useEffect(() => {
    let interval;
      if (props.paymentLinkLoader) {
        interval = setInterval(() => {
          setTimer((prevTimer) => prevTimer > 0 ? prevTimer - 1 : 0); // Decrement timer by 1 every second
        }, 1000);
      } else {
        setTimer(120); // Reset timer when paymentLinkLoader becomes false
      }
      return () => clearInterval(interval); // Cleanup on component unmount
  }, [props.paymentLinkLoader]);

  const bankDetails = {
    border: "0.8px solid #979797",
    borderRadius: '5px',
    padding: '17px 0 17px 21px',
    position: 'relative'
  }

  const label = {
    position: "absolute",
    fontSize: "13px",
    color: "#575757",
    fontWeight: "600",
    background: "#FFF",
    top: "-0.65rem",
    padding: "0 0.5rem",
    marginLeft: "-0.5rem"
  }

  useEffect(() => {
    if (props.paymentTried === true) {
      onPaymentChange("neft")
    }
  },[props.paymentTried])

  const handleToggleClick = () => {
    setpaymentMethod('upi');
    props.canclePaymentModelRfq();
  }

  return (
    <Modal 
      isOpen={openPaymentMode}
      zIndex={9999}
      centered
      className="rfq-modal"
    >
      <ModalHeader toggle={() => cancelEnable ? handleToggleClick() : null} style={{ borderBottom: "none", padding: "10px"}}></ModalHeader>
      <ModalBody>
        <>
          <div className="p-4">
            <div style={{marginBottom: "2rem"}}>
              <img style={{ height: "3rem" }} src={process.env.REACT_APP_IMAGES_PATH + "biddeasy.webp"} alt="biddeasy-logo" className=""/>
            </div>
            <p className="font-size-18 font-weight-semi-bold text-left">
              Select Payment Method
            </p>
            <div className="d-flex flex-column">
              <div className="d-flex flex-row payment-item justify-flex-start w-100">
                {(!props?.paymentTried && userAmount > 100) ? <>
                  { (userAmount < 200000) ? <div className="payment-type py-3 my-1">
                    <div class="custom-control custom-radio custom-control-inline ">
                      <input
                        type="radio"
                        id="upi"
                        name="paymentMethod"
                        class="custom-control-input"
                        checked={paymentMethod === "upi"}
                        onChange={() => onPaymentChange("upi")}
                      />
                      <label class="custom-control-label" for="upi">
                        UPI
                      </label>
                    </div>
                  </div> : null}
                  <div className="payment-type py-3 my-1">
                    <div class="custom-control custom-radio custom-control-inline ">
                      <input
                        type="radio"
                        id="netbanking"
                        name="paymentMethod"
                        class="custom-control-input"
                        checked={paymentMethod === "netbanking"}
                        onChange={() => onPaymentChange("netbanking")}
                      />
                      <label class="custom-control-label" for="netbanking">
                        Net Banking
                      </label>
                    </div>
                  </div>
                </> :
                null }
               { userAmount > 100 /* && exchange != "nse" */ ? <div className="payment-type py-3 my-1">
                  <div class="custom-control custom-radio custom-control-inline ">
                    <input
                      type="radio"
                      id="neft"
                      name="paymentMethod"
                      class="custom-control-input"
                      checked={paymentMethod === "neft"}
                      onChange={() => onPaymentChange("neft")}
                    />
                    <label class="custom-control-label" for="neft">
                      NEFT/RTGS
                    </label>
                  </div>
                </div> : null}
                <div style={{
                  padding: '20px 20px 0',
                  borderRadius: '5px',
                  border: '1px $secondary solid'
                }}>
                </div>
              </div>
              <div className="w-100 d-flex justify-content-start">
                <img src={process.env.REACT_APP_IMAGES_PATH + "DisclaimerWarning.webp"} style={{ width: "30px", height: "30px"}} />
                <p className="text-left text-secondary font-size-18 font-weight-semi-bold mr-auto ml-2">Important Details Regarding Payment</p>
              </div>
              {paymentMethod === "neft" ?
                <ul className="p-1">
                  {/* <li className="font-size-12 text-left">Kindly ensure that the payment is done on T+1 working day before 3:30 pm, failing to do so will lead to suspension of your account from Debt market for a period of 15 days as per SEBI Regulation.</li> */}
                  <li className="font-size-12 text-left list-unstyled">Please ensure that the payment bank account is same as shared during the KYC process.</li>
                </ul>

              : paymentMethod === "upi" ?
                <ul className="p-1">
                  {/* <li className="font-size-12 text-left">Kindly ensure that the payment is made within T+1 working days by 3:30 pm, failing to do so will lead to suspension of your account from Debt market for a period of 15 days as per SEBI Regulation.</li> */}
                  <li className="font-size-12 text-left list-unstyled">Please ensure that the payment bank account is same as shared during the KYC process.</li>
                </ul>
                
              : paymentMethod === "netbanking" ?
                <ul className="p-1">
                  {/* <li className="font-size-12 text-left">Kindly ensure that the payment is made today itself before 3:30 pm, failing to do so will lead to suspension of your account from Debt market for a period of 15 days as per SEBI Regulation.</li> */}
                  <li className="font-size-12 text-left list-unstyled">Please ensure that the payment bank account is same as shared during the KYC process.</li>
                </ul>  

              : null}
              
              <Collapse isOpen={paymentMethod == "neft"}>
                <div className="neft-Note">
                  <p className="note font-size-12 text-left">
                    {`Note : Kindly ensure that the NEFT/RTGS transfer is credited to the bank account before 
                      ${moment(recordDate).format("Do MMM YYYY")} (Record Date). In case the payment is delayed you may miss out on the next coupon or principal payout.`
                    }
                  </p>
                </div>
              </Collapse>
              
              <p className="font-size-12 text-left mt-1 mb-3" ><b>Your registered bank account number is as follows</b></p>

              <div style={bankDetails}>
              <p style={label}>Bank Account Number</p>
              <p className="font-size-14 text-left mb-0 mt-2" style={{ color: "#979797", fontWeight: "600" }}>
                {props?.thirdPartyData?.accountNumber && (
                  <>
                    {Array.from({ length: 12 }, (_, index) => (
                      <span key={index} className="mdi mdi-checkbox-blank-circle font-size-10"></span>
                    ))}
                    {' ' + props.thirdPartyData.accountNumber.toString().slice(-4)}
                  </>
                )}
              </p>

                {/* <p className="font-size-12 text-left mb-0" style={{ color: "#979797" }}>
                  {props?.thirdPartyData?.accountNumber && `XXXX-XXXX-XXXX-${props?.thirdPartyData?.accountNumber.toString().slice(-4)}`}
                </p> */}
              </div>
              {!props?.paymentLinkLoader ? 
              <Button
                color="secondary"
                className="font-weight-semi-bold font-size-16 mt-3 ml-auto mr-auto w-100"
                style={{ borderRadius: '10px', border: "none", minHeight: "52px"}}
                disabled={props?.paymentLinkLoader || userAmount < 100}
                onClick={()=>handlePayClick()} 
              >
                Pay Now
              </Button> 
              :
                <div className="mt-2">
                  <OroLoaderInline />
                  <p className="text-secondary text-center font-weight-semi-bold">
                  This may take up to 120 seconds. Please do not refresh or close the window.
                  <br /> Time remaining: {timer} sec 
                  </p>
                </div>}


            </div>
          </div>
        </>
      </ModalBody>
    </Modal>
  );
}
